<template>
  <div class="wrapper">
    <header class="main-header">
      <a href="#" class="logo">
        <span class="logo-mini"><b>LZCP</b></span>
        <span class="logo-lg"><b>量子智慧</b>车库</span>
      </a>
      <nav class="navbar navbar-static-top">
        <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
          <i class="fa fa-bars" />
          <span class="sr-only">Toggle navigation</span>
        </a>
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <li>
              <a href="#" data-toggle="control-sidebar" title="更换主题颜色"><i class="fa fa-palette" /></a>
            </li>
            <li class="dropdown user user-menu">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <img src="@/assets/images/avatar.png" class="user-image">
                <span class="hidden-xs" style="font-size: 9pt;">{{ principal.realName }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="dropdown-header">
                  <i class="ace-icon fa fa-motorcycle" />我的智能车库
                </li>
                <li>
                  <a href="javascript:void(0)" onclick="return false;" class="user-header">
                    <img src="@/assets/images/avatar.png" class="user-avatar" alt="我的头像">
                    <span class="user-info">
                      <span class="msg-title">用户：<span>{{ principal.realName }}</span></span>
                      <span class="msg-title" style="display: block">角色：<span>{{ principal.roleLabels | join }}</span></span>
                    </span>
                  </a>
                </li>
                <li>
                  <a @click="showMyProfileDialog()">
                    <i class="ace-icon fa fa-user blue" />我的资料
                  </a>
                </li>
                <li>
                  <a @click="showResetPasswordDialog()">
                    <i class="ace-icon fa fa-edit orange" />修改密码
                  </a>
                </li>
                <li>
                  <a href="#" class="no-border" @click="handleLogout()">
                    <i class="ace-icon fa fa-power-off red" />安全退出
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <Spin v-if="loadingStatus" fix />
    <!-- Control Sidebar -->
    <ControlSidebar />
    <aside id="slider" class="main-sidebar">
      <section class="sidebar">
        <ul ref="sideMenu" class="sidebar-menu tree" data-widget="tree">
          <slide-item
            v-for="(item,index) in menuItems"
            :key="index"
            :data="item"
            :type="item.type"
            :is-header="item.isHeader"
            :icon="item.icon"
            :name="item.name"
            :badge="badge"
            :items="item.items"
            :router="item.router"
            :link="item.link"
          />
        </ul>
      </section>
    </aside>
    <div id="content-wrap" class="content-wrapper">
      <section class="content-header">
        <tags-nav :value="$route" :list="tagNavList" @input="handleClick" @on-close="handleCloseTag" @on-refresh="handleRefreshTag" />
      </section>

      <section class="content">
        <transition name="page" mode="out-in">
          <router-view :key="$route.path + $route.query.t" />
        </transition>
      </section>
    </div>

    <ResetPasswordDialog
      :visible="modalResetPwd"
      :width="400"
      @on-close="onResetPasswordModalClose"
    />

    <MyProfileDialog
      :visible="modalMyProfile"
      :width="500"
      @on-close="onMyProfileModalClose"
    />
    <!-- Footer link -->
    <footer class="login-footer">
      <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号：</a>
      <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备20002049号</a>
    </footer>
  </div>
</template>

<script>
import SlideItem from '@/components/slide-item'
import TagsNav from '@/components/tags-nav'
import { mapMutations } from 'vuex'
// import { watermark } from 'watermark-component'
// import { watermarkIt } from 'easy-watermark'
import waterMark from '@careteen/watermark'
import { routeEqual, getRouterNameByPath } from '@/utils/util'
import { getMenu, getPrincipal, revokeToken } from '@/apis'
import jQuery from 'jquery'
// import WebSocketClient from '@/utils/ws'
import ResetPasswordDialog from './my/resetpwd'
import MyProfileDialog from './my/profile'
import ControlSidebar from '@/components/control-sidebar'
export default {
  name: 'Main',
  components: {
    'tags-nav': TagsNav,
    'slide-item': SlideItem,
    ResetPasswordDialog,
    MyProfileDialog,
    ControlSidebar
  },
  filters: {
    join(arrayData) {
      return arrayData ? arrayData.join(',') : ''
    }
  },
  data() {
    return {
      modalResetPwd: false,
      modalMyProfile: false,
      menuItems: [],
      loadingStatus: true,
      principal: [],
      socket: null,
      badge: { name: 'Dashboard', data: 0, type: 'String' }
    }
  },
  computed: {
    tagNavList() {
      return this.$store.state.app.tagNavList
    }
  },
  watch: {
    '$route'(newRoute) {
      const { name, query, params, meta } = newRoute
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      })
      this.setCurrentMenu(newRoute)
    }
  },
  mounted() {
    this.loadData()

    // this.socket = new WebSocketClient()
    // this.socket.connect('/topic/alarm', this.onAlarmReceived)
  },
  created() {

  },
  beforeDestroy() {
    this.onbeforeunload()
  },
  methods: {
    ...mapMutations([
      'addTag',
      'setTagNavList',
      'closeTag',
      'setCurrentMenu',
      'removeToken',
      'setAuthorities',
      'setUserInfo',
      'removeUserInfo',
      'removeAuthorities',
      'removeTagNavList',
      'setAccessResources',
      'removeAccessResources'
    ]),
    showResetPasswordDialog() {
      this.modalResetPwd = true
    },
    showMyProfileDialog() {
      this.modalMyProfile = true
    },
    onResetPasswordModalClose() {
      this.modalResetPwd = false
    },
    onMyProfileModalClose() {
      this.modalMyProfile = false
    },
    onAlarmReceived(message) {
      if (!isNaN(message.body)) {
        this.badge.data = parseInt(message.body)
      }
    },
    onbeforeunload() {
      // this.closeWebSocket()
    },
    closeWebSocket() {
      // this.socket.disconnect()
    },
    async loadMenus() {
      const _that = this
      await getMenu(this.$config.apiContextPath + '/menu').then(res => {
        _that.menuItems = _that.constructMenus(res.data.content)
        const { name, params, query, meta } = _that.$route
        _that.addTag({
          route: { name, params, query, meta },
          type: 'push'
        })
        // hack to re-init tree elements
        jQuery('[data-widget="tree"]').each(function() {
          jQuery.fn.tree.call(jQuery(this))
        })
      }).catch(error => {
        console.log(error)
        _that.loadingStatus = false
      })
    },
    loadData() {
      const _that = this
      this.loadingStatus = true

      // load menus
      this.loadMenus()

      // get user profile
      getPrincipal(this.$config.apiContextPath + '/me').then(res => {
        const { authorities } = res.data
        if (authorities.length === 0 || authorities.includes('ROLE_USER')) {
          // disabled for a while and must be reverted back
          this.removeToken()
          this.removeAuthorities()
          this.$router.replace({ name: 'Login' })
          this.$Notice.error({
            title: '访问被拒',
            desc: '您没有权限访问该页面!'
          })
        }
        this.principal = res.data
        this.setAuthorities(res.data.authorities)
        this.setUserInfo(res.data)
        this.setAccessResources(res.data.accessResources)

        waterMark({
          type: 'page',
          content: this.principal.realName,
          width: '150px',
          height: '100px',
          zIndex: 9999
          // rotate: '-30'
        })

        _that.loadingStatus = false
      }).catch(error => {
        console.log(error)
        _that.loadingStatus = false
      })
    },
    constructMenus: function(data) {
      const parents = []
      const leafs = []
      if (data && data.length > 0) {
        for (const item of data) {
          const options = { id: item.id, type: 'item', name: item.label, icon: 'fa ' + item.icon, expand: true, items: [],
            router: {
              name: getRouterNameByPath(item.path)
            }
          }
          if (!item.parentId) {
            parents.push(options)
          } else {
            leafs.push({ parent: item.parentId, options: options })
          }
        }

        if (leafs.length > 0) {
          for (const parent of parents) {
            for (const leaf of leafs) {
              if (leaf.parent === parent.id) {
                parent.type = 'tree'
                parent.router = {}
                parent.items.push(leaf.options)
              }
            }
          }
        }
      }
      return parents
    },
    handleClick(item) {
      this.turnToPage(item)
    },
    handleCloseTag(res, type, route) {
      if (type !== 'others') {
        if (type === 'all') {
          this.turnToPage(this.$config.homeName)
        } else {
          if (routeEqual(this.$route, route)) {
            this.closeTag(route)
          }
        }
      }
      this.setTagNavList(res)
    },
    handleRefreshTag(res, type, route) {
      if (type === 'refresh') {
        // const { name, params, query } = route
        // query.t = Date.now
        // this.$router.push({ name, params, query })
      }
    },
    handleLogout() {
      const _this = this
      this.$Modal.confirm({
        title: '确认退出系统么？',
        loading: true,
        onOk: function() {
          const _that = this
          revokeToken('/oauth/revoke').then(res => {
            _this.removeToken()
            _this.removeAuthorities()
            _this.removeAccessResources()
            _this.removeUserInfo()
            _this.removeTagNavList()
            _this.$Modal.remove()
            _this.$Notice.success({
              title: '操作成功',
              desc: '您已成功退出系统!'
            })
            _this.$router.replace({ name: 'Login' })
          }).catch(error => {
            console.log(error)
            _that.buttonLoading = false
          })
        }
      })
    },
    turnToPage(route) {
      let { name, params, query } = {}
      if (typeof route === 'string') {
        name = route
      } else {
        name = route.name
        params = route.params
        query = route.query
      }
      this.$router.push({ name, params, query })
    }
  }
}
</script>

<style lang="less" scoped>
.login-footer {
  position: fixed;
  bottom: 10px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #999;
}
.navbar-nav>.user-menu>.dropdown-menu {
  width: 200px !important;
  background-color: #2f607c;
  padding: 5px 0;
  border-radius: 4px;
}
.ace-icon {
  margin-right: 5px;
}
.dropdown-menu {
  li {
    color: #fff;
    padding: 0 8px;
    background-color: #2c3b41;

    &:hover {
      background-color: #3c8dbc !important;
    }
    // background-color: #FFF;
    a {
        padding: 8px 2px;
        margin: 0;
        border-bottom: 1px solid;
        font-size: 12px;
        line-height: 16px;
        color: #fff !important;
        background-color: transparent!important;
        white-space: normal;
        border-bottom-color: #7c8286;

    }
  }
}
.dropdown-header {
    padding: 3px 20px;
    font-size: 13px;
    white-space: nowrap;
    text-shadow: none;
    line-height: 34px;
    font-weight: 400;
    text-transform: none;
    border-bottom: 1px solid;
    // background-color: #3c8dbc !important;
    color: #8090A0;
    border-bottom-color: #7c8286;
}
.user-image {
  width: 32px !important;
  height: 32px !important;
  border: 1px solid #c5c6c6;
  margin-top: -5px !important;
}
.user-header {
  flex: 1;
  display: flex;
  align-items: center;

  .user-avatar {
    max-width: 42px;
    float: left;
    margin-top: 2px;
    vertical-align: middle;
    border: 1px solid #706d4b;
    border-radius: 50%;
  }

  .user-info {
    display: block;
    line-height: 20px;
    white-space: normal;
    margin-top: 5px;
    margin-left: 10px;
    font-size: 12px;
  }
}
.no-border {
  border: none !important;
}
</style>
